
import { useState } from "react";

export const useProfileFieldValidation = () => {
  const [fieldErrors, setFieldErrors] = useState({
    firstName: false,
    lastName: false,
    birthdate: false
  });
  const [hasErrors, setHasErrors] = useState(false);

  // Function to validate a specific field
  const validateField = (field: string, value: string) => {
    const isValid = value.trim().length > 0;
    setFieldErrors(prev => ({
      ...prev,
      [field]: !isValid
    }));
    return isValid;
  };

  // Function to validate all fields
  const validateAllFields = (firstName: string, lastName: string, birthdate: string) => {
    const firstNameValid = validateField('firstName', firstName);
    const lastNameValid = validateField('lastName', lastName);
    const birthdateValid = validateField('birthdate', birthdate);
    
    const allValid = firstNameValid && lastNameValid && birthdateValid;
    setHasErrors(!allValid);
    
    return allValid;
  };

  return {
    fieldErrors,
    hasErrors,
    setHasErrors,
    validateField,
    validateAllFields
  };
};
